<h2 mat-dialog-title>Exchange Task</h2>

<mat-dialog-content>
  <p class="exchange-dialog-description">
    Select the collector who should receive this task.
  </p>

  <app-collector-input
    [auth0Id]="collectorAuth0Id"
    [eligibilityContext]="data.eligibilityContext"
    (auth0IdChange)="onCollectorChanged($event)"
  ></app-collector-input>

  <p class="exchange-dialog-error" *ngIf="errorMessage">
    {{ errorMessage }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="!collectorAuth0Id"
    (click)="apply()"
  >
    Apply
  </button>
</mat-dialog-actions>
